import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import Home from './Home';
import Login from './Login';
import User from './User';
import Devices from './Devices';
import Settings from './Settings';
import Unauthorized from './Unauthorized';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/home" element={<Home />} />
      <Route path="/devices" element={<Devices />} />
      <Route path="/login" element={<Login />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/user" element={<User />} />
    </Routes>
  </Router>
);

reportWebVitals();